import type { NDateLocale } from './enUS'
import { ug } from 'date-fns/locale'

const dateUgCN: NDateLocale = {
  name: 'ug-CN',
  locale: ug
}

export default dateUgCN
